import * as React from "react";
import { SubCategoryCard } from "./SubCategoryCard";
import { Category, CategoryRoot } from "shared/src/types/articlesearch/Category";
import { Button, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import { trackToggleSubCategoryPanel } from "../../../utils/SearchTrackingUtil";
import { SearchQuery } from "shared/src/types/articlesearch/SearchResult";
import { sortCategoriesByAmounts } from "../../../utils/categoryUtils";

type SubCategoryPanelProps = {
    category: Category | CategoryRoot;
    query: SearchQuery;
    lines: number;
    queryLinkComponent: any;
};

type State = {
    expanded: boolean;
    screenWidth: number;
};

export class SubCategoryPanel extends React.Component<SubCategoryPanelProps, State> {
    static defaultProps = {
        lines: 2
    };

    constructor(props: SubCategoryPanelProps) {
        super(props);
        this.state = { expanded: false, screenWidth: window.innerWidth };
        this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions.bind(this));
    }

    updateWindowDimensions() {
        this.setState({ screenWidth: window.innerWidth });
    }

    toggleExpanded = () => {
        trackToggleSubCategoryPanel(!this.state.expanded);
        this.setState({ expanded: !this.state.expanded });
    };

    renderMoreButton(category: Category | CategoryRoot) {
        const childrenCount = Object.keys(category.children).length;
        const shouldShowMoreButton =
            this.state.screenWidth > 1023 ? childrenCount > 3 * this.props.lines : childrenCount > 2 * this.props.lines;
        return shouldShowMoreButton ? (
            <Button bsStyle="link" className="sd-subcategory-more-button" onClick={this.toggleExpanded}>
                {this.state.expanded ? <i className="icon-minus icon-lg"></i> : <i className="icon-plus icon-lg"></i>}
                <FormattedMessage id={this.state.expanded ? "EX_SUBCATEGORY_SHOW_LESS" : "EX_SUBCATEGORY_SHOW_MORE"} />
            </Button>
        ) : null;
    }

    render() {
        if (Object.keys(this.props.category.children).length === 0) {
            return null;
        }
        return (
            <div className="hidden-xs">
                <Row
                    className={
                        "sd-subcategory-panel " +
                        ("lines-" + this.props.lines) +
                        (this.state.expanded ? " sd-subcategory-panel-expanded" : "")
                    }>
                    {this.props.category
                        ? sortCategoriesByAmounts(Object.values(this.props.category.children)).map((category) => {
                              return SubCategoryCard({
                                  category: category,
                                  query: this.props.query,
                                  queryLinkComponent: this.props.queryLinkComponent
                              });
                          })
                        : null}
                </Row>
                {this.renderMoreButton(this.props.category)}
            </div>
        );
    }
}
